module.exports = __webpack_public_path__ + "img/14.0998d095.png";